/* Buena Vita - selling plan selected state.

   Kept in its own file rather than folded into bv-product.js because the
   guard `window.__bvProductInit` in that file means a second copy never runs;
   this needs to initialise independently.

   Why this exists at all: the chosen plan decides whether somebody is billed
   once or every four weeks. The CSS uses `:has(input:checked)`, which is fine
   on current browsers, but a purchase-critical selection state should not rest
   on a single mechanism. This mirrors it with an explicit class. */
(function () {
  'use strict';

  if (window.__bvPlansInit) return;
  window.__bvPlansInit = true;

  function sync(group) {
    var radios = group.querySelectorAll('input[type="radio"][name="selling_plan"]');
    for (var i = 0; i < radios.length; i++) {
      var card = radios[i].closest('.bv-plan');
      if (card) card.classList.toggle('is-selected', radios[i].checked);
    }
  }

  function init(scope) {
    var groups = (scope || document).querySelectorAll('.bv-plans');

    for (var i = 0; i < groups.length; i++) {
      (function (group) {
        if (group.dataset.bvBound === '1') return;
        group.dataset.bvBound = '1';

        // Marks that JS is driving the state, which lets the CSS confidently
        // clear any stale styling from unselected cards.
        group.classList.add('is-js');

        group.addEventListener('change', function () { sync(group); });
        sync(group);
      })(groups[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
